const facebook = {
    pageId: '122122101560001466',
    appId: '311393998016163'
}

export default facebook;